import { createAction, props } from '@ngrx/store';
import {Moment} from "moment";

export const removeContract = createAction('[Customer Contract] remove contract', props<{customerId: string}>());
export const bookFlatrate = createAction('[Customer Contract] book flatrate', props<{customerId: string, from: Moment, until: Moment}>());
export const bookWeekly = createAction('[Customer Contract] book weekly', props<{customerId: string, units: number, from: Moment, until: Moment}>());
export const bookMonthly = createAction('[Customer Contract] book monthly', props<{customerId: string, units: number, from: Moment, until: Moment}>());
